import gql from 'graphql-tag'

export const GET_ACTIVITIES = gql`
  query GetActivities($department_id: ID) {
    activities(department_id: $department_id) {
      id
      title
      description
      active
      department_id
      department {
        id
        name
      }
    }
  }
`

export const CREATE_ACTIVITY = gql`
  mutation CreateActivity($input: ActivityCreateInput!) {
    createActivity(input: $input) {
      id
      title
      description
      active
      department {
        id
        name
      }
    }
  }
`

export const UPDATE_ACTIVITY = gql`
  mutation UpdateActivity($id: Int!, $input: ActivityUpdateInput!) {
    updateActivity(id: $id, input: $input) {
      id
      title
      description
      active
      department {
        id
        name
      }
    }
  }
`

export const DELETE_ACTIVITY = gql`
  mutation DeleteActivity($id: Int!) {
    deleteActivity(id: $id)
  }
`
